import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { Box } from '@mui/material';

import { styles } from './styles';
import { registeredModals } from '@components/modals/registeredModals';
import { Modals } from '@core/Modal';
import SuspenseLoading from '@components/common/SuspenseLoading';

export type CommonLayoutProps = {};

const CommonLayout: React.FC<CommonLayoutProps> = () => {
  return (
    <Box sx={styles.root}>
      <Modals registeredModals={registeredModals} />
      <Suspense fallback={<SuspenseLoading />}>
        <Outlet />
      </Suspense>
    </Box>
  );
};

export default CommonLayout;
